import { piniaOfficeOffer } from '@stores/useOfficeOfferStore';
import { createApp } from 'vue';
import OtherOffers from '@pages/offer-page/other-offers/OtherOffers.vue';

export const otherOffers = () => {
  if (!document.getElementById('combinator-other-offers-app')) {
    return;
  }

  const app = createApp(OtherOffers);

  app.use(piniaOfficeOffer);
  app.mount('#combinator-other-offers-app');
};
